import { TagDetailSection } from "Tag/TagDetailSection";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import TagEditOptionsPanel from "./TagEditOptionsPanel";

const TagDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.TagDetailFrontModel>();
  const { tag, mainArea, optionsPanel } = viewModel;

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <TagDetailSection
            tag={tag}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <TagEditOptionsPanel
            listUrl={viewModel.listUrl}
            linkedItemCount={viewModel.linkedItemCount}
            data={optionsPanel}
            mainArea={mainArea}
            tag={tag}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>;
};

export default TagDetailApp;